import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { MultiSelectButton } from '../../../../../../../global/multi-select/multi-select-button';
import { addText, cancelText } from '../../../../../../../../constants/common-labels.constants';
import { scrollToBottomIfNear } from '../../../../../../../../infrastructure/utils/scroll.utils';
import { ModuleAttributesVM } from './module-attributes.viewmodel';
import { ModuleAttribute } from './module-attribute/module-attribute';
import './module-attributes-section.scss';

type Props = {
    vm: ModuleAttributesVM;
};

export const ModuleAttributesSection: React.FC<Props> = observer(({ vm }) => {
    const sectionRef = useRef<HTMLElement>(null);

    const remainingAttributeOptionsForPicker = vm.getRemainingAttributeOptions().map(attr => ({
        id: attr.eventAttributeId,
        name: attr.eventAttributeName,
    }));

    const handleAttributesSelected = (items: { id: number }[]): void => {
        if (sectionRef.current) scrollToBottomIfNear(sectionRef.current);
        vm.addAttributes(items.map(i => i.id));
    };

    return (
        <section ref={sectionRef} className='module-attributes-section'>
            <p className='module-attributes-section__header'>
                <FormattedMessage
                    id='oe.hubModule.eventAttributesHeader'
                    defaultMessage='Event Attributes'
                    description='Section header for event attributes in hub module modal'
                />
            </p>
            {vm.getAttributes().map(attrVM => (
                <ModuleAttribute
                    key={attrVM.getAttributeId()}
                    vm={attrVM}
                    onRemove={() => vm.removeAttribute(attrVM.getAttributeId())}
                />
            ))}
            <MultiSelectButton
                items={remainingAttributeOptionsForPicker}
                value={[]}
                keyProperty='id'
                nameProperty='name'
                text={
                    <FormattedMessage
                        id='oe.hubModule.addAttributes'
                        defaultMessage='+ Add Attributes'
                        description='Button to add event attributes to a hub module'
                    />
                }
                applyButtonText={addText()}
                resetButtonText={cancelText()}
                onChange={handleAttributesSelected}
                className='module-attributes-section__add-btn'
            />
        </section>
    );
});
